import { classNames } from "../Components"
import { Icon, Icons } from "./Icon"

interface CloseButtonProps {
  className?: string;
  icon?: string;
  iconClassName?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  onClick?: any;
}

export function CloseButton({ className, icon, iconClassName, onClick }: CloseButtonProps) {
  const _clickCalllback = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };
  return (
    <div className={classNames(["CloseButton", className])} onClick={onClick}>
      <Icon className={classNames(["button", iconClassName])} icon={icon || Icons.Close} />
    </div>
  );
}
